import React, { useState } from "react";
import styles from "./admincommoncomponent.module.css";
import { BsInfoCircle } from "react-icons/bs";
import Select from "react-select";
import { IoMdArrowDropdown } from "react-icons/io";
import GradientButton from "../../../Components/Button/GradientButton";
import Button from "../../../Components/Button";

const AdminCommonComponent = ({buttonClass,buttonName,handleButton, header, data,setIsResetPasswordModal }) => {
  
  const handleChange=(e)=>{
    const {name,value}=e
    // console.log(name,",",value);
  }

  return (
    <>
      <div className={styles.container}>
        <div className="flex justify-between">
        <p style={{ fontSize: "1.5rem" }}>{header}</p>
        {buttonName && <GradientButton label={buttonName} className={buttonClass}  onClick={handleButton}/>}
        </div>
        {data &&
          data.map((item) => (
            <div className={styles.items_container}>
              <span style={{ fontSize: "0.9rem" }} className="flex inline-block items-center">
                {item.label}&nbsp;&nbsp;
                <span data-title={item.title} id={styles.span} >
                  {item.title && (
                    <BsInfoCircle
                      size={"0.9rem"}
                      cursor={"pointer"}
                      style={{ paddingTop: "1px" }}
                    />
                  )}
                </span>
              </span>
              {item.value && (
                <span style={{ fontSize: "0.9rem" }}>{item.value}</span>
              )}
              {item.toggle && (
                <label className={styles.switch}>
                  <input type="checkbox" className={styles.input} onChange={handleChange}/>
                  <span className={`${styles.slider} ${styles.round}`}></span>
                </label>
              )}
              {item.dropDown && (
                <div style={{ position: "relative" }}>
                  <Select
                    value={
                      item.options &&
                      item.options.find(
                        (itm) => itm.value === item?.dropDownValue
                      )
                    }
                    className={styles.profit_input1}
                    id={styles.selet}
                    options={item?.options}
                    onChange={handleChange}
                  />
                  <IoMdArrowDropdown
                    size={"1.1rem"}
                    style={{
                      position: "absolute",
                      top: "0.7rem",
                      right: "1rem",
                    }}
                  />
                </div>
              )}
            </div>
          ))}
      </div>
    </>
  );
};

export default AdminCommonComponent;





